const QuestionCountCard = ({
	...props
}: {
	selectedAnsawer: any;
	currentQuestionIndex: number;
	totalQuestion: number;
}) => {
	return (
		<div className="rounded-lg bg-white w-[300px] h-[400px] overflow-y-auto font-subheading border-1">
			<div className="flex flex-wrap gap-3 p-6">
				<div className="flex gap-2 items-center">
					<span className="bg-[#73b3ef94] h-3 w-3 rounded-full"></span>
					<span className="font-semibold">Answered</span>
				</div>

				<div className="flex gap-2 items-center">
					<span className="bg-[#eb91003b] h-3 w-3 rounded-full"></span>
					<span className="font-semibold">Unanswered</span>
				</div>
				<div className="flex gap-2 items-center">
					<span className="bg-[#00961642] h-3 w-3 rounded-full"></span>
					<span className="font-semibold">Current Question</span>
				</div>
			</div>
			<div className="grid grid-cols-4 gap-4 p-4 justify-center font-body">
				{Array.from({ length: props.totalQuestion }, (_, index) => (
					<div
						key={index}
						className={`w-10 h-10 rounded-lg shadow-sm flex items-center justify-center  font-medium
          ${
						props.selectedAnsawer[index] !== undefined
							? // bg-[#73b3effe] means answered
							  "bg-[#73b3ef94] text-[#0B67BC]"
							: props.currentQuestionIndex === index
							? // bg-green-300 means current question
							  "bg-[#00961642] text-[#009617]"
							: // bg-[#e4b465fe] means unanswered
							  "bg-[#eb91003b] text-[#EB9200]"
					}
        `}
					>
						{index + 1}
					</div>
				))}
			</div>
		</div>
	);
};

export default QuestionCountCard;
